import { css } from '@emotion/react';

export const root = (
  color?: string,
  borderColor = '#8a8c8f',
  backgroundColor = '#fff',
  padding = '0 1.6rem',
  width?: string,
) => css`
  display: block;
  padding: ${padding};
  width: ${width || 'auto'};
  border-radius: 0.4rem;
  font-weight: 700;
  white-space: nowrap;
  transition: background 0.15s linear, color 0.15s linear;
  &[data-size='lg'] {
    height: 4.8rem;
    font-size: 1.6rem;
  }
  &[data-size='md'] {
    height: 4rem;
    font-size: 1.4rem;
  }
  &[data-active='true'],
  &[aria-disabled='true'] {
    pointer-events: none;
  }
  &[data-variant='primary'] {
    background: var(--color-primary-default);
    color: var(--color-white);
    &[data-active='true'] {
      background: var(--color-primary-active);
    }
    &[aria-disabled='true'] {
      background: var(--color-background-light);
      border: none;
      color: var(--color-text-disabled);
    }
    &:hover {
      background: var(--color-primary-hover);
      text-decoration: inherit;
    }
  }
  &[data-variant='destructive'] {
    background: var(--color-secondary-default);
    color: var(--color-white);
    &[data-active='true'] {
      background: var(--color-secondary-active);
    }
    &[aria-disabled='true'] {
      background: var(--color-background-light);
      border: none;
      color: var(--color-text-disabled);
    }
    &:hover {
      background: var(--color-secondary-hover);
      text-decoration: inherit;
    }
  }

  &[data-variant='outlined'] {
    background: var(--color-white);
    border: 1px solid ${borderColor};
    ${color ? `color: ${color};` : 'color: var(--color-text-default);'}
    &[data-active='true'] {
      background: var(--color-background-active);
    }
    &[aria-disabled='true'] {
      background: var(--color-background-light);
      border-color: var(--color-background-disabled);
      color: var(--color-text-disabled);
    }
    &:hover {
      background: var(--color-background-light);
      text-decoration: inherit;
    }
  }

  &[data-variant='text'] {
    background: var(--color-white);
    color: var(--color-text-default);
    &[aria-disabled='true'] {
      background: var(--color-background-light);
      border-color: var(--color-background-disabled);
      color: var(--color-text-disabled);
    }
    &:hover {
      background: var(--color-background-light);
      text-decoration: inherit;
    }
  }

  &[data-variant='primary-outline'] {
    background: ${backgroundColor};
    border: 1px solid var(--color-primary-default);
    color: var(--color-primary-default);
    &[data-active='true'] {
      background: var(--color-background-active);
    }
    &[aria-disabled='true'] {
      background: var(--color-background-light);
      border-color: var(--color-background-disabled);
      color: var(--color-text-disabled);
    }
    &:hover {
      background: var(--color-primary-light);
      text-decoration: inherit;
    }
  }

  &[data-variant='destructive-outline'] {
    background: var(--color-white);
    color: var(--color-secondary-active);

    &[aria-disabled='true'] {
      border-color: var(--color-background-disabled);
      color: var(--color-text-disabled);
    }
    &:hover {
      background: var(--color-secondary-light);
      text-decoration: inherit;
    }
  }

  &[data-variant='link'] {
    color: var(--secondary-default, #ea503b);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    &:hover {
      text-decoration-line: underline;
    }
  }

  &[data-variant='link-primary'] {
    color: var(--color-primary-default);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    &:hover {
      text-decoration-line: underline;
    }
  }
`;

export const inner = css`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const icon = css`
  display: inline-flex;
  padding-right: 0.8rem;
  margin-left: -0.4rem;
  svg {
    vertical-align: vam;
  }
`;
